import request from './request'

export default {
  buscarPacientePorCpf (cpf) {
    return request({
      url: `/paciente/buscarPacientePorCpfPreCadastro?cpf=${cpf}`,
      method: 'get'
    })
  },
  cadastrarPaciente (nome, cpf, dataNascimento, idOS, senha) {
    console.log('cadastrarPaceinte', nome, cpf, dataNascimento, idOS, senha)
    return request({
      url: '/paciente/cadastrar',
      method: 'post',
      data: {
        nome: nome,
        cpf: cpf,
        dataNascimento: dataNascimento,
        idOS: idOS,
        senha: senha
      }
    })
  },
  atualizarPrecadastro (idPrecadastro, status, data, idOs) {
    return request({
      url: '/paciente/atualizarPreCadastro',
      method: 'post',
      data: {
        id: idPrecadastro,
        status: status,
        data: data.getFullYear() + '-' + (data.getMonth() + 1) + '-' + data.getDate() + ' ' + data.getHours() + ':' + data.getMinutes() + ':' + data.getSeconds(),
        idOs: idOs
      }
    })
  }

}
